const initialState = {
    loadingPathology: false,
    pathologyId: '',
    pathologyDetails: [],
    pathologyViewDetails: [],
    visitFinding: {},
    generalRemark: {},
    casePathology: {},
    relatedPolicy: {},
    generalRemarkStatus: false,
    casePathologyStatus: false,
    relatedPolicyStatus: false,
    visitFindingStatus: false,
    errorsPathology: {},
}

const casePathologyReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_PATHOLOGYLISTBYID_PENDING":
        case "GET_PATHOLOGY_VIEW_LISTBYID_PENDING":
        case "VISIT_FINDING_INSERT_RADIOLOGY_PATHOLOGY_PENDING":
        case "ADD_CASE_RADIOLOGY_PATHOLOGY_GENERAL_REMARKS_PENDING":
        case "ADD_CASE_PATHOLOGY_PENDING":
        case "ADD_CASE_RADIOLOGY_PATHOLOGY_POLICY_PENDING":
            return {
                ...state,
                loadingPathology: true,
                generalRemarkStatus: false,
                casePathologyStatus: false,
                relatedPolicyStatus: false,
                visitFindingStatus: false
            };

        case "GET_PATHOLOGY_VIEW_LISTBYID_FULFILLED":
           
            return {
                ...state,
                loadingPathology: false,
                pathologyViewDetails: action.payload,
                errorsPathology: {}
            };
        case "GET_PATHOLOGYLISTBYID_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                pathologyDetails: action.payload,
                pathologyId: action.payload?.id,
                errorsPathology: {}
            };
        case "VISIT_FINDING_INSERT_RADIOLOGY_PATHOLOGY_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                visitFinding: action.payload,
                visitFindingStatus: true,
                errorsPathology: {}
            }
        case "ADD_CASE_RADIOLOGY_PATHOLOGY_GENERAL_REMARKS_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                generalRemark: action.payload,
                generalRemarkStatus: true,
                errorsPathology: {}
            }
        case "ADD_CASE_PATHOLOGY_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                casePathology: action.payload,
                casePathologyStatus: true,
                errorsPathology: {}
            }
        case "ADD_CASE_RADIOLOGY_PATHOLOGY_POLICY_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                relatedPolicy: action.payload,
                relatedPolicyStatus: true,
                errorsPathology: {}
            }
        case "GET_PATHOLOGYLISTBYID_REJECTED":
        case "GET_PATHOLOGY_VIEW_LISTBYID_REJECTED":
        case "VISIT_FINDING_INSERT_RADIOLOGY_PATHOLOGY_REJECTED":
        case "ADD_CASE_RADIOLOGY_PATHOLOGY_GENERAL_REMARKS_REJECTED":
        case "ADD_CASE_PATHOLOGY_REJECTED":
        case "ADD_CASE_RADIOLOGY_PATHOLOGY_POLICY_REJECTED":
            return {
                ...state,
                loadingPathology: false,
                errorsPathology: action.payload,
                generalRemarkStatus: false,
                casePathologyStatus: false,
                relatedPolicyStatus: false,
                visitFindingStatus: false,
            };
        case "RESET_GENERAL_STATUS":
            return {
                ...state,
                generalRemarkStatus: false,
                casePathologyStatus: false,
                relatedPolicyStatus: false,
                visitFindingStatus: false,
            };
        case "RESET_PATHOLOGY_DETAILS":
            return {
                ...state,
                pathologyDetails: [],
                pathologyId: ''
            };
        case "RESET_VISIT_FINDING":
            return {
                ...state,
                visitFinding: {}
            };
        case "RESET_GENERAL_REMARK":
            return {
                ...state,
                generalRemark: {}
            };
        case "RESET_CASE_PATHOLOGY":
            return {
                ...state,
                casePathology: {},
                casePathologyStatus: false,
            };
        case "RESET_RELATED_POLICY":
            return {
                ...state,
                relatedPolicy: {},
                relatedPolicyStatus: false,
            };
        case "RESET_PATHOLOGY_ERRORS":
            return {
                ...state,
                errorsPathology: {}
            };
        default:
            return state;
    }
}

export default casePathologyReducer;